/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import { EuiInlineEditText } from '@elastic/eui'

import type { AnyCluster } from '@modules/ccm-lib/types'

import messages from './messages'

import type { FC } from 'react'

type Props = {
  ccmCluster: AnyCluster
  canRenameCluster: boolean
  onSave: (name: string) => void
  isSaving: boolean
}

const CCMClusterNameDisplayAndEditor: FC<Props> = ({
  ccmCluster,
  canRenameCluster,
  onSave,
  isSaving,
}) => {
  const { formatMessage } = useIntl()

  return (
    <EuiInlineEditText
      readModeProps={{
        'aria-label': formatMessage(messages.editClusterNameAriaLabel),
      }}
      inputAriaLabel={formatMessage(messages.clusterNameInputAriaLabel)}
      defaultValue={ccmCluster.name}
      onSave={onSave}
      isLoading={isSaving}
      isReadOnly={!canRenameCluster}
      size='s'
    />
  )
}

export default CCMClusterNameDisplayAndEditor
